"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyEventAsStream = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var tuple_1 = require("../../functions/tuple");
var rxjs_1 = require("../../rxjs");
var use_key_event_listener_1 = require("./use-key-event-listener");
var useKeyEventAsStream = function () {
    var _a = tslib_1.__read((0, rxjs_1.useStateAsStream)(undefined), 2), 
    // dummy comment to control prettier
    onKeyDown$ = _a[0], onKeyDown = _a[1];
    var _b = tslib_1.__read((0, rxjs_1.useStateAsStream)(undefined), 2), 
    // dummy comment to control prettier
    onKeyUp$ = _b[0], onKeyUp = _b[1];
    (0, use_key_event_listener_1.useKeyEventListener)(onKeyDown, onKeyUp);
    return (0, rxjs_1.mergeTyped)(onKeyDown$.pipe((0, rxjs_1.filterNotUndefined)(), (0, operators_1.map)(function (e) { return (0, tuple_1.t)('down', e); })), onKeyUp$.pipe((0, rxjs_1.filterNotUndefined)(), (0, operators_1.map)(function (e) { return (0, tuple_1.t)('up', e); })));
};
exports.useKeyEventAsStream = useKeyEventAsStream;
